import { Component } from 'react'
import PropTypes from 'prop-types'
import '../styles/index.scss'
import WishlistTable from '../containers/WishlistTable'

class Wishlist extends Component {
  componentDidMount() {
    const { syncWishlistedProductsToStore } = this.props
    syncWishlistedProductsToStore()

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/buyer-wishlist.js')
        .then(registration => console.log('service worker registration successful', registration))
        .catch(error => console.log('service worker registration successful', error.message))
    }
  }

  render() {
    return (
      <>
        <header className='w_header'>
          <h3 className='title'>My Wishlist</h3>
        </header>
        <div className='wproduct__wrapper'>
          <WishlistTable />
        </div>
      </>
    )
  }
}

Wishlist.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  removeWishlistedProduct: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
}

export default Wishlist

